import axios from 'axios'
import router from '@/router'

let isRedirecting = false // 防止重复跳转
export const baseURL = 'https://zjwax.com'

// ====== 创建 axios 实例 ======
const service = axios.create({
  baseURL, // FastAdmin 接口前缀
  timeout: 60000
})

// ====== 请求拦截器 ======
service.interceptors.request.use(config => {

  config.headers['Content-Type'] = 'application/json'

  // 如果有 token
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['token'] = token
  }

  return config
}, error => {
  return Promise.reject(error)
})

// ====== 响应拦截器 ======
service.interceptors.response.use(response => {
  const res = response.data
  console.log(1111,res);
  if (res.code === 401) {
    if (!isRedirecting) {
      isRedirecting = true
      router.push('/login').finally(() => {
        // 1秒后重置状态，防止未来的401能再次跳转
        setTimeout(() => (isRedirecting = false), 1000)
      })
    }
    router.push('/login')
    return Promise.reject(new Error('未登录或登录已过期'))
  }

  if (res.code !== 1) {
    return Promise.reject(new Error(res.msg || 'Error'))
  }

  return res
}, error => {
  if (error.response && error.response.status === 401) {
    if (!isRedirecting) {
      isRedirecting = true
      localStorage.removeItem('token')
      router.push('/login').finally(() => {
        setTimeout(() => (isRedirecting = false), 1000)
      })
      return Promise.reject(new Error('请重新登录' || 'Error'))
    }
    return new Promise(() => {})
  }
  return Promise.reject(error)
})

export default service